import React, {useState, useEffect} from "react";
import { USERPILOT_TOKEN } from './../libs/firebase.js';
import { initUserpilot, identifyUser, disableUserpilot } from './../libs/userpilotManager.ts';
import { useIsEU } from './../hooks/useIsEU';
import { EUOnlyCookieConsent } from './EUOnlyCookieConsent';
import { useLoginState } from "../studioxr/auth/LoginState.ts";


export const EUCookieAndUserPilot = ({ currentUser }) => {
    const profile = useLoginState((state) => state.profile);
    const isEU = useIsEU();
    const [pilotEnabled, setPilotEnabled] = useState(false);
    const [consentStatus, setConsentStatus] = useState<'accepted' | 'declined' | null>(() => {
        const stored = localStorage.getItem('cookieConsent');
        if (stored === 'accepted' || stored === 'declined') return stored;
        return null;
    });
      
      // Non-EU: init immediately
      useEffect(() => {
        if (isEU === false && !pilotEnabled) {
          initUserpilot(USERPILOT_TOKEN);
          setPilotEnabled(true);
        }
      }, [isEU, pilotEnabled]);
    
      // Identify user if Userpilot is active
      useEffect(() => {
        if (pilotEnabled && currentUser && profile) {
          identifyUser({currentUser, profile});
        }
      }, [pilotEnabled, currentUser, profile]);
    
      const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        initUserpilot(USERPILOT_TOKEN);
        setPilotEnabled(true);
        setConsentStatus('accepted');
      };
    
      const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        disableUserpilot();
        setPilotEnabled(false);
        setConsentStatus('declined');
      };
    
      return (
        <>
            {isEU && consentStatus === null && (
                <EUOnlyCookieConsent
                    onAccept={handleAccept}
                    onDecline={handleDecline}
                />
            )}
        </>
      );
}